import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as DeleteIcon } from "../../img/trashicon.svg";
import EditModal from "./editmodalbahanbaku";
import { formatNumber } from "../../numberingformat"; // Ensure formatNumber works for formatting
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/shadcn/dialog";
import { Button } from "src/components/shadcn/button";


export default function IngredientsCategoryTable() {
  const navigate = useNavigate();
  const [data, setData] = useState([]); // State to store API data
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sort state
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [modalData, setModalData] = useState(null); // Manage modal data
  const [isModalOpen, setIsModalOpen] = useState(false); // Manage modal visibility
    const [isPopupVisible, setIsPopupVisible] = useState(false)
      const [isPopupFailedVisible, setIsPopupFailedVisible] = useState(false)
  const [newCategory, setNewCategory] = useState("")
  const [newCategoryDescription, setNewCategoryDescription] = useState("");
  const storedUserId = localStorage.getItem("userAuthentication");

const handleSubmitNewCategory = async () => {
  if (!newCategory.trim()) return;

  try {
    await instance2.post("/ingredient_category_master", {
  name: newCategory,
  description: newCategoryDescription,
      admin_id: storedUserId
});


    setIsPopupVisible(false);
    setNewCategoryDescription("")
    setNewCategory("");

    // ✅ Refetch categories after successful addition
    fetchData();
  } catch (err) {
    console.error("Failed to add category:", err);
    setIsPopupFailedVisible(true)
  }
};

 // Inside IngredientsTable
const fetchData = async () => {
  try {
    const response = await instance2.get("ingredient_category_master");
    if (response.status === "OK") {
      setData(response.data);
    } else {
      throw new Error("Failed to fetch data");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setError(error.message);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchData();
}, []);

console.log("data", data)

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
      if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return "";
  };

  const filteredData = data.filter((item) => {
    const searchValue = searchQuery.toLowerCase();

    return (
      (item.name?.toLowerCase().includes(searchValue) || false) ||
      (item.description?.toLowerCase().includes(searchValue) || false) //||
    //   (item.description?.toLowerCase().includes(searchValue) || false) ||
    //   (item.uoq_name?.toLowerCase().includes(searchValue) || false) ||
    //   (item.buffer?.toString().toLowerCase().includes(searchValue) || false) ||
    //   (item.multiple_qty?.toString().toLowerCase().includes(searchValue) || false) || // Handle numeric fields
    //   (item.frequency_name?.toLowerCase().includes(searchValue) || false)
    );
  });

 const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
   const itemsPerPage = 10; // Number of items per page
     // Pagination logic
     const totalPages = Math.ceil(filteredData.length / itemsPerPage);
     const paginatedData = filteredData.slice(
       (currentPage - 1) * itemsPerPage,
       currentPage * itemsPerPage
     );
   
     const handlePreviousPage = () => {
       if (currentPage > 1) setCurrentPage(currentPage - 1);
     };
   
     const handleNextPage = () => {
       if (currentPage < totalPages) setCurrentPage(currentPage + 1);
     };
   
     // Determine which page numbers to show
     let pageNumbers = [];
     const maxVisiblePages = 5;
   
     if (totalPages <= maxVisiblePages) {
       pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
     } else {
       if (currentPage <= 3) {
         // Near the beginning
         pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
       } else if (currentPage >= totalPages - 2) {
         // Near the end
         pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
       } else {
         // In the middle
         pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
       }
     }

  const handleEdit = (item) => {
    setModalData(item); // Set the selected item data for the modal
    setIsModalOpen(true); // Open the modal
  };

// --- STATE ---
const [confirmOpen, setConfirmOpen] = useState(false);
const [resultOpen, setResultOpen] = useState(false);
const [resultTitle, setResultTitle] = useState("");
const [resultMsg, setResultMsg] = useState("");
const [blockingNames, setBlockingNames] = useState([]);
const [deleting, setDeleting] = useState(false);
const [deleteTarget, setDeleteTarget] = useState(null);

// open confirm dialog
const onClickDelete = (item) => {
  setDeleteTarget(item);
  setConfirmOpen(true);
};

// confirm deletion -> call API
const confirmDeleteNow = async () => {
  if (!deleteTarget) return;
  setDeleting(true);

  try {
    const res = await instance2.delete(`/ingredient_category/${deleteTarget.id}`);

    // prefer backend status field if present
    const httpStatus = res?.status;

    if (httpStatus === "OK" || httpStatus === 200) {
      // ✅ success
      setConfirmOpen(false);
      setResultTitle("Sukses");
      setResultMsg("Data telah terhapus.");
      setBlockingNames([]);
      setResultOpen(true);
      fetchData(); // Refresh table
      return;
    }

    // Non-OK but not thrown (rare): treat as blocked/error payload
    const raw = Array.isArray(res?.data?.data)
      ? res.data.data
      : Array.isArray(res?.data)
      ? res.data
      : [];
    const names = raw.map((x) => x?.name).filter(Boolean);

    setConfirmOpen(false);
    setResultTitle("Tidak Bisa Dihapus");
    setResultMsg("Mohon hapus data bahan baku di bawah terlebih dahulu:");
    setBlockingNames(names.length ? names : ["(Tidak ada rincian)"]);
    setResultOpen(true);
  } catch (e) {
    const httpStatus = e?.response?.status;
    const apiStatus  = e?.response?.data?.status;

    // 🔴 500 (or backend status "ERROR"): show blocker dialog + names list
    if (httpStatus === 500 || apiStatus === "ERROR") {
      const raw = Array.isArray(e?.response?.data?.data)
        ? e.response.data.data
        : Array.isArray(e?.response?.data)
        ? e.response.data
        : [];
      const names = raw.map((x) => x?.name).filter(Boolean);

      setConfirmOpen(false);
      setResultTitle("Tidak Bisa Dihapus");
      setResultMsg("Mohon hapus data BAHAN BAKU di bawah terlebih dahulu:");
      setBlockingNames(names.length ? names : ["(Tidak ada rincian)"]);
      setResultOpen(true);
    } else {
      // generic/unexpected error
      setConfirmOpen(false);
      setResultTitle("Gagal");
      setResultMsg(e?.response?.data?.message || "Terjadi kesalahan. Coba lagi.");
      setBlockingNames([]);
      setResultOpen(true);
    }
  } finally {
    setDeleting(false);
    setDeleteTarget(null);
  }
};


  return (
    <div className="p-4">
      <div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
        <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Kategori Bahan Baku</h2>
        <button
          type="button"
          onClick={() => setIsPopupVisible(true)}
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Tambah Kategori Bahan Baku
        </button>
      </div>

      {/* Search Bar */}
      <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
        <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
          <MagnificationLogo className="w-6 h-6"/>
          <VerticalLine className="mx-1" />
          <input
            type="text"
            placeholder="Telusuri data berdasarkan nama kategori bahan baku"
            className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
            style={{
              width: `${"Telusuri data berdasarkan nama kategori bahan baku".length}ch`,
            }}
            value={searchQuery} // Controlled input
            onChange={(e) => setSearchQuery(e.target.value)} // Update search query
          />
        </div>
      </div>

      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">Error: {error}</p>
      ) : (
        <>
          <table className="table-fixed w-full border-collapse text-left">
            <thead>
              <tr className="bg-white">
                {/* Table headers */}
                <th
                  className="w-[25px] lg:w-[50px] border-b px-4 py-2 rounded-tl-[15px] text-xxs md:text-xxs lg:text-base"
                >
                  No.
                </th>
                <th
                  className="border-b px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("name")}
                >
                  Nama <span className="float-right">{getSortArrow("name")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("description")}
                >
                  Deskripsi <span className="float-right">{getSortArrow("description")}</span>
                </th>
                {/* <th
                  className="border-b px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("uoq_id")}
                >
                  Unit <span className="float-right">{getSortArrow("uoq_id")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 cursor-pointer text-center text-xxs md:text-xxs lg:text-base lg:w-1/10"
                  onClick={() => handleSort("multiple_qty")}
                >
                  Kelipatan <span className="float-right">{getSortArrow("multiple_qty")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("frequency_id")}
                >
                  Frekuensi <span className="float-right">{getSortArrow("frequency_id")}</span>
                </th>
                <th
                  className="border-b px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base lg:w-1/10"
                  onClick={() => handleSort("buffer")}
                >
                  Buffer (%) <span className="float-right">{getSortArrow("buffer")}</span>
                </th> */}
                <th
                  className="border-b px-4 py-2 cursor-pointer rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base"
                  onClick={() => handleSort("createdat")}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
          {[
    ...paginatedData,
    ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
      empty: true, // Add an "empty" object for invisible rows
    })),
  ].map((item, index) => (
    <tr
    key={item.id}
    className={`hover:bg-gray-200 ${
      index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
    } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300 "}`}
  >
                  {/* Table rows */}
                  <td className="px-4 py-2 w-[25px] lg:w-[50px] text-xxs md:text-xxs lg:text-base">{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                  <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.name}</td>
                  <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.description || "-"}</td>
                  {/* <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.uoq_name || "N/A"}</td>
                  <td className="px-4 py-2 text-right text-xxs md:text-xxs lg:text-base lg:w-1/2">{formatNumber(item.multiple_qty)}</td>
                  <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.frequency_name}</td>
                  <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base text-right lg:w-1/2">{item.buffer}</td> */}
                  <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                    <button
                      className="text-gray-500 p-2 rounded hover:text-green-500"
                      onClick={() => handleEdit(item)}
                    >
                      <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                    </button>
                    <button
                      className="text-gray-500 p-2 rounded hover:text-red-500"
                      onClick={() => onClickDelete(item)}
                    >
                      <DeleteIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
        </>
      )}
      {/* Edit Modal */}
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
  <DialogContent>
    <DialogHeader>
      <DialogTitle>Ubah Kategori</DialogTitle>
    </DialogHeader>

    <div className="space-y-4">
      {/* Nama Kategori */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Nama Kategori</label>
        <input
          type="text"
          value={modalData?.name || ""}
          onChange={(e) =>
            setModalData({ ...modalData, name: e.target.value })
          }
          className="w-full px-3 py-2 border rounded-md text-sm"
        />
      </div>

      {/* Deskripsi */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Deskripsi</label>
        <textarea
          value={modalData?.description || ""}
          onChange={(e) =>
  setModalData({
    ...modalData,
    description: e.target.value
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()),
  })
}
          className="w-full px-3 py-2 border rounded-md text-sm"
          rows={3}
          placeholder="Deskripsi kategori (opsional)"
        />
      </div>
    </div>

    <DialogFooter>
      <Button variant="ghost" onClick={() => setIsModalOpen(false)}>
        Batal
      </Button>
      <Button
        onClick={async () => {
          try {
            await instance2.put(`ingredient_category_master/${modalData.id}`, {
              name: modalData.name,
              description: modalData.description, // include this in the payload
            });
            setIsModalOpen(false);
            fetchData(); // Refresh table
          } catch (err) {
            console.error("Update failed:", err);
          }
        }}
      >
        Simpan
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>

<Dialog open={isPopupVisible} onOpenChange={setIsPopupVisible}>
  <DialogContent onInteractOutside={(e) => e.preventDefault()}>
    <DialogHeader>
      <DialogTitle>Tambah Kategori Baru</DialogTitle>
    </DialogHeader>

    {/* Nama Kategori */}
    <input
      type="text"
      placeholder="Nama kategori"
      value={newCategory}
      onChange={(e) => setNewCategory(e.target.value)}
      className="w-full border rounded px-2 py-1 mt-2 uppercase"
    />

    {/* Deskripsi */}
    <textarea
      placeholder="Deskripsi kategori (opsional)"
      value={newCategoryDescription}
      onChange={(e) => setNewCategoryDescription(e.target.value)}
      className="w-full border rounded px-2 py-1 mt-2 text-sm"
      rows={3}
    />

    <DialogFooter className="sm:justify-end">
      <DialogClose asChild>
        <button className="mt-2 px-4 py-2 text-sm text-black">
          Batal
        </button>
      </DialogClose>
      <button
        className="mt-2 px-4 py-2 bg-merah-no text-white rounded"
        onClick={handleSubmitNewCategory}
      >
        Simpan
      </button>
    </DialogFooter>
  </DialogContent>
</Dialog>

      <>
            <Dialog open={isPopupFailedVisible} onOpenChange={setIsPopupFailedVisible}>
              <DialogContent >
                <DialogHeader>
                  <DialogTitle>Pemberitahuan</DialogTitle>
                </DialogHeader>
                <div>Gagal mengirim data</div>
                  <DialogClose asChild>
                    <button className="ml-2 px-4 py-2 text-sm text-gray-600">
                      Keluar
                    </button>
                  </DialogClose>
              </DialogContent>
            </Dialog>
          </>


          {/* Confirm dialog delete */}
<Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
  <DialogContent>
    <DialogHeader>
      <DialogTitle>Konfirmasi Hapus</DialogTitle>
      <DialogDescription>
        Hapus <b>{deleteTarget?.name || "item ini"}</b>? Tindakan tidak dapat dibatalkan.
      </DialogDescription>
    </DialogHeader>

    <DialogFooter className="gap-2">
      <button
        type="button"
        className="px-4 py-2 rounded"
        onClick={() => setConfirmOpen(false)}
        disabled={deleting}
      >
        Batal
      </button>
      <button
        type="button"
        className="px-4 py-2 rounded bg-merah-no hover:bg-merah-hover text-white disabled:opacity-60"
        onClick={confirmDeleteNow}
        disabled={deleting}
      >
        {deleting ? "Menghapus..." : "Ya, Hapus"}
      </button>
    </DialogFooter>
  </DialogContent>
</Dialog>

{/* Result / Info dialog */}
<Dialog open={resultOpen} onOpenChange={setResultOpen}>
  <DialogContent>
    <DialogHeader>
      <DialogTitle>{resultTitle}</DialogTitle>
      <DialogDescription>{resultMsg}</DialogDescription>
    </DialogHeader>

    {blockingNames.length > 0 && (
      <div className="mt-3 text-sm">
        <ul className="list-disc pl-5 space-y-1">
          {blockingNames.map((n, i) => (
            <li key={`${n}-${i}`}>{n}</li>
          ))}
        </ul>
      </div>
    )}

    <DialogFooter>
      <button
        type="button"
        className="px-4 py-2 rounded bg-gray-200"
        onClick={() => setResultOpen(false)}
      >
        Tutup
      </button>
    </DialogFooter>
  </DialogContent>
</Dialog>


    </div>
  );
}
